/* eslint-disable react/function-component-definition */
import {
  currencyCodeSchema,
  indicatorDataSourceSchema,
  interimSchema,
  objectIdsRefSchema,
  parseAsDate,
  statementTypeSchema,
} from "components/ux/urlParsers";
import { parseAsNumberLiteral, parseAsString, parseAsStringLiteral, useQueryState, useQueryStates } from "nuqs";
import { IFinancialsStatementType } from "types/graphqlTypes";

export function useFinancialsQueryState() {
  const [selectedIndicators, setSelectedIndicators] = useQueryState("indicators", objectIdsRefSchema.withDefault([]));
  const [dataSource, setDataSource] = useQueryState("dataSource", indicatorDataSourceSchema);
  const [currency, setCurrency] = useQueryState("currency", currencyCodeSchema);
  const [templateId, setTemplateId] = useQueryState("template", parseAsString);
  const [tab, setTab] = useQueryState("tab", parseAsStringLiteral(["COMPARE", "CHART", "TABLE"]).withDefault("TABLE"));
  const [statementTypeWithInterim, setStatementTypeWithInterim] = useQueryStates({
    statementType: statementTypeSchema.withDefault(IFinancialsStatementType.Annual),
    interim: interimSchema,
  });
  const [limit, setLimit] = useQueryState("limit", parseAsNumberLiteral([10, 15, 30, 45]).withDefault(10));
  const [reportDateBeforeAfter, setReportDates] = useQueryStates({
    before: parseAsDate,
    after: parseAsDate,
  });

  return {
    selectedIndicators,
    dataSource,
    currency,
    statementType: statementTypeWithInterim.statementType
      ? (statementTypeWithInterim.statementType.toUpperCase() as IFinancialsStatementType)
      : null,
    interim: statementTypeWithInterim.interim,
    reportDates: [reportDateBeforeAfter.before, reportDateBeforeAfter.after] as [Date | null, Date | null],
    templateId,
    tab,
    limit,

    setSelectedIndicators,
    setDataSource,
    setStatementTypeWithInterim,
    setCurrency,
    setReportDates,
    setTemplateId,
    setTab,
    setLimit,
  };
}
